<div class="modal-header"><h2 class="modal-title">Allocate Order</h2></div>
<div class="modal-body">
    <div class="row">
        <div class="col-sm-3">
            <h4>Selected OrderLineDetail</h4>
            <table class="table">
                <tbody *ngIf="orderLineDetail">
                    <tr>
                        <td>Dealer</td>
                        <td>{{ orderLineDetail.orderLine.order.dealer.companyName }}</td>
                    </tr>
                    <tr>
                        <td>Order #</td>
                        <td>{{ orderLineDetail.orderLine.order.invoiceNumber }}</td>
                    </tr>
                    <tr>
                        <td>Part #</td>
                        <td>{{ orderLineDetail.orderLine.partNumber }}</td>
                    </tr>
                    <tr>
                        <td>PO #</td>
                        <td>{{ orderLineDetail.orderLine.order.pONumber }}</td>
                    </tr>
                    <tr>
                        <td>VIN</td>
                        <td>{{ orderLineDetail.vIN }}</td>
                    </tr>
                    <tr>
                        <td>Qty</td>
                        <td>{{ orderLineDetail.quantity }}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{{ orderLineDetail.status.name }}</td>
                    </tr>
                    <tr>
                        <td>Built</td>
                        <td>{{ orderLineDetail.built | date : 'shortDate' }}</td>
                    </tr>

                    <tr>
                        <td>Options</td>
                        <td [innerHTML]="orderLineDetail.optionHTML" style="font-size: x-small !important"></td>
                    </tr>
                    <tr>
                        <td>Notes</td>
                        <td [innerHTML]="orderLineDetail.noteHTML" style="font-size: x-small !important"></td>
                    </tr>
                    <tr>
                        <td>Order Tier Pricing</td>
                        <td>{{ orderLineDetail.orderLine.order.pricingTier.name }}</td>
                    </tr>
                    <tr>
                        <td>Total</td>
                        <td>{{ total | currency }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-sm-6">
            <div class="grid-fill">
                <dx-data-grid
                    #dataGrid
                    [dataSource]="matchingOrders"
                    keyExpr="id"
                    height="650px"
                    [showBorders]="true"
                    (onSelectionChanged)="selectionChange(dataGrid.instance.getSelectedRowsData()[0])"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                >
                    <dxi-column dataField="id" caption="DetailId" width="65"></dxi-column>
                    <dxi-column dataField="orderLine.order.invoiceNumber" caption="Order #" width="80"></dxi-column>
                    <dxi-column dataField="orderLine.order.dealer.companyName" caption="Dealer" width="100"></dxi-column>
                    <dxi-column dataField="quantity" caption="Qty" width="65"></dxi-column>
                    <dxi-column dataField="orderLine.partNumber" caption="Part #" width="125"></dxi-column>
                    <dxi-column dataField="vIN" caption="Vin #" width="100"></dxi-column>
                    <dxi-column dataField="optionHTML" caption="Options" width="250" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
                    <dxi-column dataField="noteHTML" caption="Notes" width="250" [encodeHtml]="false" [allowSearch]="true"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarTextBefore'">
                        <h4>Matching Orders</h4>
                    </div>
                    <div *dxTemplate="let data of 'toolbarTextAfter'">
                        <span *ngIf="matchingOrders" class="me-3">
                            <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
                        </span>
                    </div>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                </dx-data-grid>
            </div>
        </div>
        <div class="col-sm-3 d-flex flex-column">
            <div class="flex-fill">
                <h4>Matching Options</h4>
                <table class="table">
                    <tbody>
                        <tr *ngFor="let option of matchingOptions">
                            <td>{{ option }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex-fill">
                <h4>Missing Options (will be deleted)</h4>
                <table class="table">
                    <tbody>
                        <tr *ngFor="let option of missingOptions">
                            <td>{{ option }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex-fill">
                <h4>Additional Options (need to be added to trailer)</h4>
                <table class="table">
                    <tbody>
                        <tr *ngFor="let option of additionalOptions">
                            <td>{{ option }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex-fill">
                <h4>Pricing Tiers</h4>
                <table class="table">
                    <tbody>
                        <tr>
                            <td>Allocating From: {{ orderLineDetail?.orderLine.order.pricingTier.name }}</td>
                        </tr>
                        <tr>
                            <td>Allocating To: {{ selectedMatchingOrder?.orderLine.order.pricingTier.name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="!this.selectedMatchingOrder" (click)="save()">Save</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
</div>
